document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-mobile-toggle]');
  const mobileNav = document.querySelector('.vg-mobile');
  if (menuButton && mobileNav) {
    const closeMenu = () => {
      mobileNav.classList.remove('is-open');
      menuButton.setAttribute('aria-expanded', 'false');
    };
    menuButton.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenu(); });
    mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  }

  document.querySelectorAll('[data-qty-minus]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value) - 1);
  }));
  document.querySelectorAll('[data-qty-plus]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Number(input.value) + 1;
  }));

  const mainImage = document.querySelector('[data-main-product-image]');
  const select = document.querySelector('[data-product-select]');
  const mainForm = document.querySelector('#main-product-form');
  const mainAddButton = mainForm?.querySelector('.add-button');
  const stockRow = document.querySelector('[data-stock-row]');
  const stockText = document.querySelector('[data-stock-text]');
  const stickyBar = document.querySelector('[data-sticky-atc]');
  const stickyButton = document.querySelector('[data-sticky-add]');

  const updateVariant = () => {
    if (!select) return;
    const option = select.selectedOptions[0];
    const available = option.dataset.available === 'true';
    document.querySelectorAll('[data-variant-id]').forEach(input => { input.value = option.value; });
    document.querySelectorAll('[data-product-price]').forEach(node => { node.textContent = option.dataset.price || ''; });
    document.querySelectorAll('[data-sticky-price]').forEach(node => { node.textContent = option.dataset.price || ''; });
    document.querySelectorAll('[data-product-compare]').forEach(node => { node.textContent = option.dataset.compare || ''; });
    document.querySelectorAll('[data-product-save]').forEach(node => { node.textContent = option.dataset.save || ''; });
    if (mainImage && option.dataset.image) { mainImage.src = option.dataset.image; mainImage.srcset = ''; }
    if (stockText) stockText.textContent = available ? 'Available to order' : 'Currently unavailable';
    if (stockRow) stockRow.classList.toggle('is-unavailable', !available);
    if (mainAddButton) { mainAddButton.disabled = !available; mainAddButton.textContent = available ? 'Add to cart' : 'Sold out'; }
    if (stickyButton) { stickyButton.disabled = !available; stickyButton.textContent = available ? 'Add to cart' : 'Sold out'; }
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  };

  if (select) {
    select.addEventListener('change', updateVariant);
    document.querySelectorAll('[data-option-group] input').forEach(input => input.addEventListener('change', () => {
      const group = input.closest('[data-option-group]');
      const label = group.querySelector('[data-selected-option]');
      if (label) label.textContent = input.value;
      const selected = [...document.querySelectorAll('[data-option-group] input:checked')].map(item => item.value);
      const match = [...select.options].find(option => [option.dataset.option1, option.dataset.option2, option.dataset.option3].filter(Boolean).every((value, index) => value === selected[index]));
      if (match) { select.value = match.value; updateVariant(); }
    }));
    updateVariant();
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
    if (mainImage && thumb.dataset.imageUrl) { mainImage.src = thumb.dataset.imageUrl; mainImage.srcset = ''; }
    document.querySelectorAll('[data-gallery-thumb]').forEach(item => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }));

  if (stickyBar && mainAddButton && mainForm) {
    const observer = new IntersectionObserver(entries => {
      const visible = !entries[0].isIntersecting;
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0 });
    observer.observe(mainAddButton);
    stickyButton?.addEventListener('click', () => mainForm.requestSubmit(mainAddButton));
  }

  const filterButton = document.querySelector('[data-filter-toggle]');
  const collectionSidebar = document.querySelector('[data-collection-sidebar]');
  if (filterButton && collectionSidebar) filterButton.addEventListener('click', () => {
    const open = collectionSidebar.classList.toggle('is-open');
    filterButton.setAttribute('aria-expanded', String(open));
  });

  document.querySelectorAll('[data-story-section]').forEach(section => {
    const tabs = [...section.querySelectorAll('[data-story-tab]')];
    const panels = [...section.querySelectorAll('[data-story-panel]')];
    tabs.forEach(tab => tab.addEventListener('click', () => {
      const id = tab.dataset.storyTab;
      tabs.forEach(item => { const active = item === tab; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); });
      panels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.storyPanel === id));
    }));
  });
});
